import React, { TouchEvent, useContext, useState } from "react"
import { AppDispatch } from "../../../.."
import { useDispatch } from "react-redux"
import {
  clearAlert,
  setWarningAlerts,
} from "../../../../globalStore/alertStore"
import cardReadingImage from "../../../../source/img/truck_man_card_read_image.png"
import { ModalOuter } from "../../../../components/Tablet/ModalOuter"
import truckMan from "../../../../source/img/takuhai_truck_man.png"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import TenkosyaInfo from "../../../../components/Tablet/TenkosyaInfo"
import BackButton from "../../../../components/Tablet/BackButton"
import useSyainCardReader from "../../../../ts/hooks/useSyainCardReader"
import { useHistory } from "react-router-dom"
import {
  selectSyainByNumberPage,
  selectTenkoTimingPage,
} from "../../../../constant/tablet/pages"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTired } from "@fortawesome/free-solid-svg-icons"
import { TZyomuinGetRes } from "../../../../service/driver/TZyomuin"
import ZyomuinService from "../../../../service/driver/zyomuinService"
import { ZyomuinContext } from "../../context/context"
import { sleep } from "../../../../ts/hooks/useRFC380Reader"
import SpinnerInTablet from "../../../../components/SpinnerInTablet"

const SelectZyomuinByICCard = React.memo(() => {
  const dispatch: AppDispatch = useDispatch()
  const history = useHistory()
  const { set乗務員 } = useContext(ZyomuinContext)
  const [isSearching, setIsSearching] = useState(false)

  const { NfcCardReader, deviceStatus, scanCardReader, NFCReadOFF } =
    useSyainCardReader(async (cardId) => {
      dispatch(clearAlert())
      setIsSearching(true)
      try {
        const 社員Res = await new ZyomuinService().getByCardId(cardId)

        if (社員Res && 社員Res.data) {
          set乗務員Inner(社員Res.data)
          setModalShow(true)
        } else {
          dispatch(
            setWarningAlerts(["乗務員コードと一致する乗務員が見つかりません"])
          )
        }
      } catch (error) {
        throw error
      } finally {
        setIsSearching(false)
      }
    })

  const [乗務員Inner, set乗務員Inner] = useState<TZyomuinGetRes>()
  const [modalShow, setModalShow] = useState(false)

  const cancel: (event: TouchEvent<HTMLDivElement>) => void = (e) => {
    //モーダルクリックの貫通防止
    e.preventDefault()
    e.stopPropagation()
    set乗務員Inner(undefined)
    setModalShow(false)
    scanCardReader()
  }

  const move時点選択: (event: TouchEvent<HTMLDivElement>) => void = (e) => {
    //モーダルクリックの貫通防止
    e.preventDefault()
    e.stopPropagation()
    set乗務員(乗務員Inner)
    history.push(selectTenkoTimingPage.Route.path)
  }

  const move社員番号入力: (event: TouchEvent<HTMLDivElement>) => void = async (
    e
  ) => {
    //モーダルクリックの貫通防止
    e.preventDefault()
    e.stopPropagation()
    // NFCReadOFF()

    NFCReadOFF()

    do {
      await sleep(10)
    } while (NfcCardReader?.opened)

    history.push(selectSyainByNumberPage.Route.path)
  }

  return (
    <>
      <SpinnerInTablet searching={isSearching}></SpinnerInTablet>
      <TenkosyaInfo>{deviceStatus}</TenkosyaInfo>
      <table
        style={{
          tableLayout: "fixed",
          height: CSS_PROPERTY.BODY_TABLE_HEIGHT,
          paddingBottom: "3rem",
        }}
        className="w-100">
        <tbody>
          <tr>
            <td colSpan={2}>
              {NfcCardReader == null ? (
                <div style={{ fontSize: "1.5rem" }}>
                  <div className="text-danger mt-5">
                    カードリーダ－が認識できませんでした。
                  </div>
                  <div className="text-danger">
                    画像をタッチしてカードリーダーを認識させてください。
                  </div>
                </div>
              ) : (
                <>
                  点呼するドライバーの社員証をカードリーダーにタッチしてください。
                </>
              )}
            </td>
          </tr>
          <tr onClick={scanCardReader}>
            <td colSpan={2} className="text-center">
              <div>
                <img
                  src={cardReadingImage}
                  style={{ height: "20rem", width: "auto" }}
                  alt=""></img>
              </div>
              {NfcCardReader != null && (
                <div style={{ fontSize: "1.5rem" }}>
                  {!deviceStatus
                    ? "読取モード停止中... 画面をタッチして読取モードにしてください"
                    : "カード読取中..."}
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td className="align-bottom">
              <BackButton
                addProc={async () => {
                  NFCReadOFF()

                  do {
                    await sleep(10)
                  } while (NfcCardReader?.opened)

                  return
                }}
              />
            </td>
            <td className="align-bottom">
              <div
                className="d-inline-block"
                onTouchStart={move社員番号入力}
                style={{
                  bottom: "0",
                  backgroundColor: "#ffdacc",
                  color: "black",
                  width: "25rem",
                  textAlign: "center",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                }}>
                <span>
                  <FontAwesomeIcon
                    icon={faTired}
                    style={{ color: CSS_PROPERTY.WARN_COLOR }}
                  />
                  社員証忘れ
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ModalOuter
        isShow={modalShow}
        dialogClassName="w-75"
        isAnimation={false}
        setIsShow={setModalShow}>
        <table
          style={{ height: "40rem", width: "100%" }}
          onClick={(e) => {
            //モーダルクリックの貫通防止
            e.preventDefault()
            e.stopPropagation()
          }}>
          <tbody>
            <tr>
              <td
                colSpan={2}
                className="text-center"
                style={{ fontSize: "3rem" }}>
                以下の乗務員の点呼を開始します。よろしいですか？
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="text-center align-middle my-3">
                <table className="d-inline-block">
                  <tbody>
                    <tr>
                      <td>
                        <div
                          className="text-end align-middle"
                          style={{
                            height: "20rem",
                            width: "100%",
                            backgroundColor: "white",
                          }}>
                          <img
                            src={truckMan}
                            style={{
                              height: "100%",
                              width: "auto",
                            }}
                            alt=""></img>
                        </div>
                      </td>
                      <td className="text-center" style={{ fontSize: "5rem" }}>
                        <table>
                          <tbody>
                            <tr>
                              <td className="text-end">
                                {乗務員Inner?.部所コード}
                              </td>
                              <td>:</td>
                              <td className="text-start">
                                {乗務員Inner?.部所略称}
                              </td>
                            </tr>
                            <tr>
                              <td className="text-end">
                                {乗務員Inner?.社員コード}
                              </td>
                              <td>:</td>
                              <td className="text-start">
                                {乗務員Inner?.社員氏名}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr className="text-center" style={{ fontSize: "4rem" }}>
              <td className="w-50">
                <div
                  className="d-inline-block"
                  onTouchStart={cancel}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.OK_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>再入力</span>
                </div>
              </td>
              <td className="w-50">
                <div
                  className="d-inline-block"
                  onTouchStart={move時点選択}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.WARN_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>確定</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ModalOuter>
    </>
  )
})

export default SelectZyomuinByICCard
